<template>
  <DataComponent/>
</template>

<script>
  import DataComponent from '../components/DataComponent'

  export default {
    components: {
      DataComponent
    }
  }
</script>